import { endpoints } from "../../configs/Settings";
import { HTTPResponseStatus } from "../../utils/enum";
import { useAuth } from "../../utils/useAuth";
import { useAxios } from "../../utils/useAxios";

export interface InstitutionResource {
  id: string;
  idDocumento: string | null;
}

interface GetInstitutionResourcesProps {
  cnpj: string;
}

/**
 * Busca os recursos consentidos para uma instituição pelo CNPJ.
 */
export async function GetInstitutionResources({
  cnpj,
}: GetInstitutionResourcesProps) {
  const url = `${endpoints.CONSENT}/instituicao/${cnpj}/recurso`;
  const headers = {
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/json",
    Accept: "*/*",
  };

  const response = await useAxios
    .get<InstitutionResource[]>(url, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`GetInstitutionResources: ${response.status}`);
      }
      return { status: HTTPResponseStatus.Success, data: response.data };
    })
    .catch((error) => {
      console.error("GetInstitutionResources ", error);
      throw new Error();
    });

  if (response) return response;
}
